var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693",
    "data-name": "Rectangle 1693",
    width: 35,
    height: 22.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-CAT_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CAT_",
    "data-name": "CAT +",
    clipPath: "url(#clip-CAT_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2559",
    "data-name": "Groupe 2559",
    transform: "translate(6 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2559-2",
    "data-name": "Groupe 2559",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6983",
    "data-name": "Trac\\xE9 6983",
    d: "M31.4,4.8H2.7A2.1,2.1,0,1,1,2.7.6H31.4a2.1,2.1,0,0,1,0,4.2",
    transform: "translate(0.452 0.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6984",
    "data-name": "Trac\\xE9 6984",
    d: "M31.4,5.4H2.7A2.7,2.7,0,1,1,2.7,0H31.4a2.7,2.7,0,0,1,0,5.4ZM2.7,1.2a1.5,1.5,0,0,0,0,3H31.4a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(0.452 0.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6985",
    "data-name": "Trac\\xE9 6985",
    d: "M23.887,9.887H5.7a2.7,2.7,0,1,1,0-5.4H23.887a2.7,2.7,0,0,1,0,5.4ZM5.7,5.69a1.5,1.5,0,0,0,0,3H23.887a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(2.707 3.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6986",
    "data-name": "Trac\\xE9 6986",
    d: "M16.376,14.374H8.7a2.7,2.7,0,1,1,0-5.4h7.677a2.7,2.7,0,1,1,0,5.4ZM8.7,10.177a1.5,1.5,0,0,0,0,3h7.677a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(4.963 7.2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.fde669d775187db440031667ba557be4.svg";
export { ForwardRef as ReactComponent };